import React, { useState } from "react"
import Box from "@mui/material/Box"
import { Typography } from "@mui/material"
import ButtonWithIcon from "../Button/Button"
import { ReactComponent as PlusSquareIcon } from "src/v2/assets/icons/plus-square-icon.svg"
import { ReactComponent as FileIcon } from "src/v2/assets/icons/file-icon.svg"
import { ReactComponent as DeleteIcon } from "src/v2/assets/icons/close-square-icon.svg"

import PropTypes from "prop-types"

const UploadComponent = ({ fileInputRef, onFileSelect }) => {
    const [selectedFile, setSelectedFile] = useState(null)
    const [isDragging, setIsDragging] = useState(false)

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        if (onFileSelect) {
            onFileSelect(file)
        }
    }

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const handleDragEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragging(false)
    }
    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const file = e.dataTransfer.files[0]
        if (file) {
            setSelectedFile(file)
            if (onFileSelect) {
                onFileSelect(file)
            }
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
    }

    const handleClickDeleteButton = () => {
        setSelectedFile(null)
        if (fileInputRef.current) {
            fileInputRef.current.value = ""
        }
        onFileSelect(null)
    }

    if (selectedFile) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 2,
                    }}
                >
                    <FileIcon />
                    <Typography
                        color="common.white"
                        variant="textBody"
                        sx={{
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                        noWrap
                    >
                        {selectedFile?.name}
                    </Typography>
                </Box>
                <ButtonWithIcon
                    icon={<DeleteIcon />}
                    onClick={handleClickDeleteButton}
                >
                    EXCLUIR
                </ButtonWithIcon>
            </Box>
        )
    }

    return (
        <Box
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                border: isDragging
                    ? "2px dashed #E3A404"
                    : "1px dashed #FFFFFF",
                paddingY: "40px",
            }}
        >
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".csv, .pdf, .doc, .docx, .xlsx, .xls, .ptx, .ppt"
            />
            <Box
                sx={{
                    display: "flex",
                    width: "fit-content",
                    whiteSpace: "nowrap",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <ButtonWithIcon
                    size={"lg"}
                    icon={<PlusSquareIcon />}
                    onClick={handleButtonClick}
                >
                    ENVIAR ARQUIVO
                </ButtonWithIcon>
                <Typography variant="body2" color="common.white">
                    Ou arraste e solte os arquivos aqui
                </Typography>
            </Box>
        </Box>
    )
}
UploadComponent.propTypes = {
    fileInputRef: PropTypes.object.isRequired,
    onFileSelect: PropTypes.func,
}

export default UploadComponent
